import { render } from "./SectionName.vue?vue&type=template&id=0febcdbd&scoped=true"
import script from "./SectionName.vue?vue&type=script&lang=js"
export * from "./SectionName.vue?vue&type=script&lang=js"

import "./SectionName.vue?vue&type=style&index=0&id=0febcdbd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0febcdbd"

export default script